


















import Vue from 'vue';
import { Model, Prop } from 'vue-property-decorator';
import Component from 'vue-class-component';
import ISelectOption from '@frontend/types/base/ISelectOption';
import RadioButton from './components/RadioButton.vue';

@Component({
	components: {
		RadioButton
	}
})
export default class RadioGroup extends Vue {
	@Model('input', { type: String, default: null })
	protected readonly checkedValue!: string | null;

	@Prop({ type: String, default: '' })
	protected readonly name!: string;

	@Prop(Array)
	protected readonly options!: ISelectOption[];

	@Prop({ type: Boolean, default: false })
	protected readonly required!: boolean;

	@Prop({ type: Boolean, default: false })
	protected readonly hasError!: boolean;
}
